import {
  ShipmentEntryType,
  LabelOptionsModel,
  LabelOptionsRewriteModel,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

export const isReturnShipment = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  return (
    labelOptions?.shipmentEntryType === ShipmentEntryType.Return ||
    labelOptionsRewrite?.shipmentEntryType === ShipmentEntryType.Return
  )
}

export const isPackageTypeLabelTypeFlow = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  if (labelOptionsRewrite?.dropOffs) {
    return labelOptionsRewrite.dropOffs.some(dropOff =>
      dropOff.options?.some(
        option =>
          Array.isArray(option.labelTypes) &&
          option.labelTypes.length > 1 &&
          option.freeReusablePackagingAvailable,
      ),
    )
  }

  if (
    Array.isArray(labelOptions?.availableLabelTypes) &&
    labelOptions.availableLabelTypes.length > 1 &&
    Array.isArray(labelOptions?.dropOffTypes) &&
    labelOptions.dropOffTypes.length > 1
  ) {
    return true
  }

  return false
}
